<template>
    <tempalte v-if="children?.length > 0">
        <template v-for="child in children" :key="child.id">
            <div class="text-sm text-gray-600 lowercase">{{ $n(child.price, 'currency') }} / {{ child.label }} / {{ child.priceType?.label }}</div>
        </template>
    </tempalte>
</template>

<script setup>
const props = defineProps({
    children: {
        type: Array
    }
})
</script>
